export default "__VITE_ASSET__F8TQh8Js__"